import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useApiMutation } from "../../../Hooks/useApiMutation";
import instance from "../../../Interceptor/api_instance";
import { Spinner } from "../../../Components/LoadingAnimations/LoadingAnimations";

const NewDoc = ({ close, onCreate, maintenanceReportId }) => {
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);

  const { mutate, isLoading, error } = useApiMutation(async (e) => {
    e.preventDefault();
    const formData = new FormData();
    const data = {
      reference_model: "maintenance",
      reference_id: maintenanceReportId,
      blob_type: "work_order"
    }
    formData.append("data", JSON.stringify(data));
    files.forEach((file) => {
      formData.append("files", file);
    });
    const res = await instance.post(`/files/blobs/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (res.status === 201) {
      onCreate(res.data);
      close();
    }
  });
  return (
    <div className="page-mask page-mask-animation">
      <div className="white-cont">
        <form onSubmit={mutate}>
          <h2 className="">Add additional documents</h2>
          <input
            type="file"
            multiple
            onChange={(e) => setFiles(Array.from(e.target.files))}
            required
          />
          {error && <p className="error">{t("forms.responses.failure")}</p>}
          <div className="full-cont">
            {isLoading ? (
              <Spinner />
            ) : (
              <>
                <button className="change-pwd-btn" type="submit">
                  {t("buttons.submit")}
                </button>
                <button className="cancel-btn" type="button" onClick={close}>
                  {t("buttons.cancel")}
                </button>
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewDoc;
